import { IComponentOptions } from "angular";
import { MachineProgressiveGameDetailViewDetailGameViewComponentController } from "./controller";

export const vsComponentName = "machineProgressiveGameDetailViewComponent";

export const machineProgressiveGameDetailViewComponentOptions: IComponentOptions =
  {
    controller:
      MachineProgressiveGameDetailViewDetailGameViewComponentController,
    controllerAs: "progressiveViewController",
    template: require("!html-loader!./index.html").default,
    bindings: {
      machineConfigurationType: "<",
      progressiveGames: "<",
    },
  };
